import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import DiagnosticExam from "@/pages/DiagnosticExam";
import ExamResults from "@/pages/ExamResults";
import CoursePage from "@/pages/CoursePage";
import EnrollmentPage from "@/pages/EnrollmentPage";
import AdminPage from "@/pages/AdminPage";
import MiCurso from "@/pages/MiCurso";
import ModuloDetalle from "@/pages/ModuloDetalle";
import ProfesorPage from "@/pages/ProfesorPage";
import SimuladorPage from "@/pages/SimuladorPage";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/examen-diagnostico" element={<DiagnosticExam />} />
          <Route path="/resultados" element={<ExamResults />} />
          <Route path="/curso" element={<CoursePage />} />
          <Route path="/inscripcion" element={<EnrollmentPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/profesor" element={<ProfesorPage />} />
          <Route path="/mi-curso" element={<MiCurso />} />
          <Route path="/mi-curso/modulo/:moduleId" element={<ModuloDetalle />} />
          <Route path="/mi-curso/simulador/:simulatorId" element={<SimuladorPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
